import { Outlet } from 'react-router-dom';
import styles from './mainLayout.module.scss';
import { useContext } from 'react';
import { DiefCfemContext } from '../contexts/DiefCfemContext';
import PageTitle from './components/pageTitle/pageTitle';
import Breadcrumb from './components/breadcrumb/breadcrumb';
import Notificacoes from './components/notificacoes/notificacoes';

function MainLayout() {
  const context = useContext(DiefCfemContext);
  return (
    <main className={styles.content}>
      <Notificacoes mensagens={context?.mensagens} />
      <div className={`container ${styles.container}`}>
        <Breadcrumb crumbs={context?.crumbs} />
        <PageTitle />
        <Outlet />
      </div>
    </main>
  );
}

export default MainLayout;
